import { render } from "./list.vue?vue&type=template&id=002fcdda&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"

import "./list.vue?vue&type=style&index=0&id=002fcdda&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-002fcdda"

export default script